module.exports = __webpack_public_path__ + "static/img/1.b031dcd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/4/eng/1.png
// module id = dUwp
// module chunks = 0